var moduleSocialSharing = function() {
  var $ = jQuery,
      _this;

  var module = {
    init: function() {
      _this = this;
      this.modifyDOM();
      this.addEvents();
      $.getScript('//platform.twitter.com/widgets.js');
      $.getScript('//apis.google.com/js/platform.js');
    },

    modifyDOM: function() {
    },

    addEvents: function() {
    },

    eventHandlers: {
    },

    helpers: {
    }
  };

  module.init();
};
